import { ForestOutlineIcon } from './ForestOutlineIcon';

/**
 * author: Jeff Anders
 * id E247BE22-952A-42FB-9741-F4607385A99B
 * name forest-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/forest-outline.svg
 * tags
 * - Nature 
 * - Agriculture 
 * - Places 
 */
export const PineTreeMultipleOutlineIcon = ForestOutlineIcon;
export default PineTreeMultipleOutlineIcon